import { Select } from "antd";
import { StaticDropdownProps } from "../../Interfaces/dropdownInterfaces";
import { useState } from "react";
import { matchesDropdownSearch } from "src/Utils/dropdownSearch";

export interface OptionType {
  value: string;
  label: string;
}

const { Option } = Select;

const StaticDropdown: React.FC<StaticDropdownProps> = ({
  dropdown,
  options,
  value,
  onChange,
}: StaticDropdownProps) => {
  const [searchValue, setSearchValue] = useState("");

  const OnDropChange = (nextValue: string | number) => {
    if (nextValue || nextValue === 0) onChange(dropdown.name, nextValue);
    else onChange(dropdown.name, null);

    setSearchValue("");
  };

  const GetValue = (v: any): string | null => {
    if (!v && v !== 0) return null;

    if (!options) return null;

    return (
      options.find((x) => x.id?.toString() === v?.toString())?.name || null
    );
  };

  const getOptions = () => {
    const res: Array<{
      value: any;
      label: string;
      additional?: JSX.Element;
      prefix?: JSX.Element;
      disabled?: boolean;
    }> = [];
    (options || []).forEach((option) => {
      res.push({
        value: option.id,
        label: option.name,
        additional: option.additional,
        prefix: option.prefix,
        disabled: option.disabled,
      });
    });
    return res;
  };

  const handleSearch = (nextSearch: string) => {
    setSearchValue(nextSearch);
  };

  return (
    <div className="w-full flex flex-col justify-start items-start gap-1">
      {dropdown.extraLabel ? (
        <div className="text-[10px]">{dropdown.placeholder}</div>
      ) : (
        <></>
      )}

      <Select
        disabled={dropdown.disabled}
        value={GetValue(value)?.toString()}
        showSearch
        onSearch={handleSearch}
        allowClear
        placeholder={dropdown.placeholder}
        style={{ width: "100%" }}
        dropdownMatchSelectWidth={false}
        popupClassName="dropdown-popup-fit-content"
        getPopupContainer={() => document.body}
        onChange={OnDropChange}
        filterOption={false}
        onClear={() => setSearchValue("")}
        tagRender={() => <></>}
      >
        {getOptions()
          .filter((option) =>
            matchesDropdownSearch(option.label, searchValue),
          )
          .map((option) => (
            <Option key={option.value} value={option.value} disabled={option.disabled}>
                  <div className="inline-flex flex-row justify-start items-center gap-2 whitespace-nowrap">
                    {option.additional ? <div>{option.additional}</div> : null}
                    <span>{option.label}</span>
                    {option.prefix ? <div>{option.prefix}</div> : null}
                  </div>
            </Option>
          ))}
      </Select>
    </div>
  );
};

export default StaticDropdown;
